import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import { withTranslation} from "react-i18next";
import commonActions from "../../../Actions/commonActions";
import customerActions from "../../../Actions/customerActions";
import React, {useEffect} from "react";
import forms from "../../../Constants/forms";
import CustomerConnectionsForm from "../../CustomerConnections/CustomerConnectionsForm";
import StandardModal, {ModalSize} from "../../Fundamentals/Modal/StandardModal";

function CustomerConnectionsEditModal ({customer, customerActions, commonActions, form, onClose, t, saving }) {

    useEffect(() => {
        commonActions.loadDropdownList("CustomerConnectionDiscounts")
    }, [])
    const handleClickSave = () => {
        customerActions.saveCustomerConnections(form, customer.vbCustomer?.customerNumber ?? customer.vossCustomer?.customerNumber, onClose);
    }
    function onCancel() {
        commonActions.cancelFormEditing(form.id, onClose);
    }

    return (
        <StandardModal title={t('customerconnections.editcustomerconnections')}
                       isLoading={saving} 
                       onClose={onCancel}
                       size={ModalSize.X_LARGE} 
                       onSubmit={handleClickSave}>
            <CustomerConnectionsForm form={form} />
        </StandardModal>
    );
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        customerConnections: state.CustomerReducer.customerConnections,
        dropdownlists: state.CommonReducer.dropdownlists,
        form: state.CommonReducer.forms && state.CommonReducer.forms[forms.customerConnectionsFormData],
        saving: state.CommonReducer.dataLoading.saveCustomerConnections,
        user: state.CommonReducer.user
    }
}


function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerConnectionsEditModal));
